export const   animationList= [
    "bounce",
    "flash",
    "flip",
    "headShake",
    "hinge",
    "jello",
    "pulse",
    "rubberBand",
    "shake",
    "swing",
    "tada",
    "wobble",
    "bounceIn",
    "bounceInDown",
    "bounceInLeft",
    "bounceInRight",
    "bounceInUp",
    "fadeIn",
    "fadeInDown",
    "fadeInDownBig",
    "fadeInLeft",
    "fadeInLeftBig",
    "fadeInRight",
    "fadeInRightBig",
    "fadeInUp",
    "fadeInUpBig",
    "flipInX",
    "flipInY",
    "lightSpeedIn",
    "rollIn",
    "rotateIn",
    "rotateInDownLeft",
    "rotateInDownRight",
    "rotateInUpLeft",
    "rotateInUpRight",
    "slideInDown",
    "slideInLeft",
    "slideInRight",
    "slideInUp",
    "zoomIn",
    "zoomInDown",
    "zoomInLeft",
    "zoomInRight",
    "zoomInUp",
    "bounceOut",
    "bounceOutDown",
    "bounceOutLeft",
    "bounceOutRight",
    "bounceOutUp",
    "fadeOut",
    "fadeOutDown",
    "fadeOutDownBig",
    "fadeOutLeft",
    "fadeOutLeftBig",
    "fadeOutRight",
    "fadeOutRightBig",
    "fadeOutUp",
    "fadeOutUpBig",
    "flipOutX",
    "flipOutY",
    "lightSpeedOut",
    "rollOut",
    "rotateOut",
    "rotateOutDownLeft",
    "rotateOutDownRight",
    "rotateOutUpLeft",
    "rotateOutUpRight",
    "slideOutDown",
    "slideOutLeft",
    "slideOutRight",
    "slideOutUp",
    "slideOutRight",
    "zoomOut",
    "zoomOutDown",
    "zoomOutLeft",
    "zoomOutRight",
    "zoomOutUp"
]

export const aos= [{
    image: "1.jpg",
    animation: "fade-down"
},
{
    image: "2.jpg",
    animation: "zoom-out-down"
},
{
    image: "3.jpg",
    animation: "flip-down"
},
{
    image: "4.jpg",
    animation: "fade-up"
},
{
    image: "5.jpg",
    animation: "flip-down"
},
{
    image: "6.jpg",
    animation: "fade-up"
},
{
    image: "7.jpg",
    animation: "flip-down"
},
{
    image: "8.jpg",
    animation: "fade-up"
},
{
    image: "9.jpg",
    animation: "flip-down"
},
{
    image: "10.jpg",
    animation: "fade-up"
},
{
    image: "11.jpg",
    animation: "flip-down"
},
{
    image: "12.jpg",
    animation: "fade-up"
},
{
    image: "14.jpg",
    animation: "flip-down"
},
{
    image: "15.jpg",
    animation: "flip-left"
},
{
    image: "13.jpg",
    animation: "flip-down"
},
{
    image: "4.jpg",
    animation: "zoom-out"
},
{
    image: "5.jpg",
    animation: "flip-right"
},
{
    image: "6.jpg",
    animation: "zoom-out"
},
{
    image: "7.jpg",
    animation: "zoom-out-up"
},
{
    image: "8.jpg",
    animation: "zoom-out-down"
},
{
    image: "9.jpg",
    animation: "flip-down"
},
{
    image: "10.jpg",
    animation: "slide-up"
},
{
    image: "9.jpg",
    animation: "flip-down"
},
{
    image: "10.jpg",
    animation: "fade-up"
},
{
    image: "11.jpg",
    animation: "flip-down"
},
{
    image: "12.jpg",
    animation: "fade-up"
},
{
    image: "14.jpg",
    animation: "flip-down"
},
{
    image: "15.jpg",
    animation: "flip-left"
},
{
    image: "13.jpg",
    animation: "flip-down"
},
{
    image: "4.jpg",
    animation: "zoom-out"
},
{
    image: "5.jpg",
    animation: "flip-right"
},
{
    image: "6.jpg",
    animation: "zoom-out"
},
{
    image: "7.jpg",
    animation: "zoom-out-up"
},
]

export const scroll= [{
    image: "01.jpg"
},
{
    image: "02.jpg"
},
{
    image: "03.jpg"
},
{
    image: "04.jpg"
},
{
    image: "05.jpg"
},
{
    image: "06.jpg"
},
{
    image: "07.jpg"
},
{
    image: "08.jpg"
},
{
    image: "09.jpg"
},
{
    image: "010.jpg"
},
{
    image: "011.jpg"
},
{
    image: "012.jpg"
},
{
    image: "013.jpg"
},
{
    image: "014.jpg"
},
{
    image: "015.jpg"
},
{
    image: "016.jpg"
},
{
    image: "01.jpg"
},
{
    image: "02.jpg"
},
{
    image: "03.jpg"
},

{
    image: "04.jpg"
},
{
    image: "05.jpg"
},
{
    image: "010.jpg"
},
{
    image: "011.jpg"
},
{
    image: "012.jpg"
},
]